import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Vigor",
    "spell_nature_earthbindtotem",
    [
      "Increases your maximum Energy by 10. In addition, your abilities that add combo points restore 10 Energy when cast on enemies below 35% health.",
    ],
    1,
    [[]],
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    {
      isNew: false,
      isChanged: true,
      isMoved: false,
    }
  ),
  null,
  null,
];

export default tier7;
